import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";

const DashboardKpiCard = ({
  title,
  value,
  caption,
  icon,
  accentColor = "#2AF598",
  borderColor = "rgba(42, 245, 152, 0.2)",
  isLoading = false,
  isHero = false,
  delta,
}) => {
  if (isLoading) {
    return <Skeleton height={isHero ? 150 : 104} style={{ borderRadius: 12 }} />;
  }

  const hasDelta = typeof delta === "number" && Number.isFinite(delta);
  const deltaColor = delta >= 0 ? "#2AF598" : "#F52A2D";

  return (
    <Card
      sx={{
        height: "100%",
        background: isHero
          ? "linear-gradient(135deg, #353535 0%, #1e1e1e 100%)"
          : "linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)",
        border: `1px solid ${borderColor}`,
        borderRadius: "12px",
        boxShadow: isHero
          ? "0 8px 24px rgba(0, 0, 0, 0.35)"
          : "0 2px 8px rgba(0, 0, 0, 0.3)",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
        },
      }}
    >
      <CardContent sx={{ p: isHero ? { xs: 2, md: 2.5 } : 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ color: "#aaa", fontSize: "13px", fontWeight: 600, mb: 1 }}>
              {title}
            </Typography>
            <Typography
              sx={{
                color: "#fff",
                fontSize: isHero ? { xs: "24px", md: "32px" } : { xs: "19px", md: "22px" },
                fontWeight: 800,
                lineHeight: 1.15,
                wordBreak: "break-word",
              }}
            >
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              width: isHero ? 46 : 38,
              height: isHero ? 46 : 38,
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.06)",
              color: accentColor,
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
        </Box>
        {(caption || hasDelta) && (
          <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            {caption && (
              <Typography sx={{ color: "#aaa", fontSize: "12px", lineHeight: 1.4 }}>
                {caption}
              </Typography>
            )}
            {hasDelta && (
              <Typography sx={{ color: deltaColor, fontSize: "12px", fontWeight: 700 }}>
                {delta >= 0 ? "+" : ""}
                {delta.toFixed(1)}% MoM
              </Typography>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardKpiCard;
